import { useState, useEffect } from 'react';
import { notificationApiService } from '../../services/notificationApiService';
import NotificationCenter from './NotificationCenter';

export default function NotificationBell() {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // Initial load
    updateUnreadCount();
    
    // Set up polling every 30 seconds for real-time updates
    const interval = setInterval(updateUnreadCount, 30 * 1000); // 30 seconds
    return () => clearInterval(interval);
  }, []);

  const updateUnreadCount = async () => {
    try {
      const count = await notificationApiService.getUnreadCount();
      setUnreadCount(count);
    } catch (error) {
      console.error('Failed to update unread count:', error);
    }
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    
    // Refresh notifications when opening the notification center
    if (!isOpen) {
      updateUnreadCount();
      console.log('🔔 Refreshing notifications on bell click');
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    // Update unread count when closing (in case user marked notifications as read)
    updateUnreadCount();
  };

  return (
    <>
      <button
        onClick={handleToggle}
        className="relative p-2 text-gray-600 hover:text-healthy-green hover:bg-green-50 rounded-full transition-colors"
        title="Notifications"
      >
        {/* Bell Icon */}
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
        </svg>
        
        {/* Notification Badge */}
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium min-w-[20px]">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      <NotificationCenter isOpen={isOpen} onClose={handleClose} onCountUpdate={updateUnreadCount} />
    </>
  );
}